import React from "react";
import { resolveImageUrl } from "../../utils/imageVariants";
import SmartImage from "./SmartImage";

export function GalleryImage({
  image,
  src,
  fallback = "",
  surfaceKey = "gallery.tile",
  alt = "",
  fit,
  fill = true,
  sizes = "100vw",
  className = "h-full w-full",
  imageClassName = "",
  transparentBackground,
  ...props
}) {
  const source = image ?? src;
  const fallbackUrl = resolveImageUrl(fallback || src || image, "");
  const shouldUseTransparentBackground =
    transparentBackground ?? surfaceKey === "gallery.lightbox";

  return (
    <SmartImage
      image={source}
      fallback={fallbackUrl}
      surfaceKey={surfaceKey}
      alt={alt}
      fit={fit}
      fill={fill}
      sizes={sizes}
      className={className}
      imageClassName={imageClassName}
      transparentBackground={shouldUseTransparentBackground}
      {...props}
    />
  );
}

export default React.memo(GalleryImage);
